import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { EMAIL_REGEX } from 'util/constants';
import { update } from 'actions/onboarding';
import H1 from 'components/deprecated/legacyElements/H1';

import styles from './style.module.scss';

export class ResultsPage extends PureComponent {
  static propTypes = {
    update: PropTypes.func.isRequired,
    email: PropTypes.string.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    phone: PropTypes.string.isRequired,
  };

  onChangeField = (evt) => {
    this.props.update({
      [evt.target.name]: evt.target.value,
    });
  };

  render() {
    return (
      <div className={styles.profileForm}>
        <div>
          <H1>
            Search, discover, and secure the right office space at no added cost
          </H1>
        </div>
        <input
          type="email"
          name="email"
          pattern={EMAIL_REGEX}
          title={`${this.props.email} is not a valid email`}
          placeholder="Work Email (required)"
          value={this.props.email}
          disabled={this.props.isLoggedIn}
          onChange={this.onChangeField}
          required
        />
        <input
          type="tel"
          name="phone"
          pattern="^[ ()+*#\-]*(?:\d[ ()+*#\-]*){7,40}$"
          title="Please enter a valid phone number (digits only)"
          maxLength="40"
          placeholder="Phone Number (required)"
          value={this.props.phone}
          onChange={this.onChangeField}
          required
        />
        <input type="submit" value="See Your Results" />
      </div>
    );
  }
}

export default compose(
  connect(
    (state) => ({
      isLoggedIn: !!state.user.currentUser,
      city: state.onboarding.city,
      neighborhoods: state.onboarding.neighborhoods,
      totalSquareFeet: state.onboarding.totalSquareFeet,
      name: state.user.currentUser
        ? state.user.currentUser.displayName
        : state.onboarding.name,
      companyName: state.onboarding.companyName,
      email: state.user.currentUser
        ? state.user.currentUser.email
        : state.onboarding.email,
      phone: state.onboarding.phone,
      renterComments: state.onboarding.renterComments,
    }),
    {
      update,
    }
  )
)(ResultsPage);
